import ReplaceTemplatesForCategory from '@/connection/categories/replace-templates-for-category';
import { TemplatesReducerCreator } from '../types';

const replaceTemplatesForCategoryReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async (payload: { categoryUuid: string; templateUuids: string[] }) => {
      return ReplaceTemplatesForCategory(payload);
    },
    {
      fulfilled: (state, action) => {
        const payload = action.payload;
        state.categoryFilters = (state.categoryFilters || []).map((category) => {
          if (category.uuid === payload.uuid) {
            return payload;
          }
          return category;
        });
      },
      rejected: (state, action) => {
        console.error(action.error);
      },
    }
  );
};

export default replaceTemplatesForCategoryReducer;
